import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signIn } from "../../redux/actions/preChatActions";
import { useNavigate } from "react-router-dom";
import { getUrlParam } from '../../utils/common';
import { setPage } from '../../redux/actions/commonActions';
// Uncomment engagement-related actions if necessary
// import { resetEngagement, setEngagementParameters } from '../../store/engagement/actions';

export const AutoSignIn = ({ mParam, mUsername, mEmail, mReferer }) => {
  const { user, ui } = useSelector((state) => state);
  const navigate = useNavigate();
  const formikRef = useRef();
  const firstNameRef = useRef();
  const config = ui?.config?.attributes || {};  // Fallback to empty object
  const appApp = config.appApp || {};
  let lang = "EN";

  const langMap = {
      "en-IN": "in",
      "kk": "kz",
      "zh-Hans": "cn",
      "ko-KR": "kr",
      "vi": "vn",
      "ne": "np",
      "zh-Hant": "cn",
      "bn-BD": "bd",
      "en-PK": "pk"
      // Add more mappings as needed
  };
  
  lang = config?.locale;
  if (langMap[config.locale]) {
      lang = langMap[config.locale];
  }
  lang = lang?.toUpperCase();

  const dispatch = useDispatch();

  const AutoSubmit = () => {

    if (config?.locale) {
        dispatch(setPage('auto-pre-chat'));

      user.brand = getUrlParam('brand') || 'Dafa';
      user.level = getUrlParam('level') || 'REG';
      user.lang = lang || 'EN';
      user.country = config.countryCode || '';
      user.source = 'EWC';
      user.product = getUrlParam('product') || '';
      user.payment = getUrlParam('payment') || '';
      user.opm = getUrlParam('otherpayment') || 'NULL';
      user.init_msg = mParam || config.init_msg;
      user.referer = mReferer || config.source || '';
      user.refererPlatform = navigator.userAgent;

      let brand = 'dafabet';
      const brandMapping = {
        'dfbt': 'dafabet',
        'sevenbaby': '777baby',
      };

      brand = brandMapping[config?.Template?.Brand] || config?.Template?.Brand;

      let product = user.product.toLowerCase();
      if (product === 'dafabet') {
        product = "Dafabet";
      }

      const lastPathSegment = window.location.pathname.split('/').pop();
      if (lastPathSegment === 'dafa-spain') {
        brand = 'dafabetes';
      }

      if (window.location.hostname === 'istg-chat.elysium-dfbt.com') {
        brand = "istg-" + brand;
        lang = "ISTG " + lang;
      }

      user.cat = brand || 'Dafa';

      const customValues = [
        { title: 'IP', value: config?.PreChatSurvey.clientIp || '202.151.35.161' },
        { title: 'country', value: config?.PreChatSurvey.countryCode || '' },
        { title: 'referer', value: user.referer },
        { title: 'RefererPlatform', value: user.refererPlatform },
        { title: 'CustomerVerified', value: config?.PreChatSurvey.customerVerified ?? "false" },
        { title: 'language', value: lang || 'EN' },
        { title: 'CustomerSegment', value: 'false' },
        { title: 'SuggestedPM', value: user.payment },
        { title: 'OtherPM', value: user.opm },
        { title: 'Restart', value: 'false' },
        { title: 'skillset', value: 'WC_EN_Dafa_Casino_REG_PT' },
        { title: 'username', value:  mUsername ? mUsername : config?.PreChatSurvey.customerVerified === "true" ? config?.PreChatSurvey.username : '' },
        { title: 'name', value: mUsername ? mUsername : config?.PreChatSurvey.customerVerified === "true" ? config?.PreChatSurvey.username : '' },
        { title: 'email', value: mEmail ? mEmail : config?.PreChatSurvey.customerVerified === "true" ? config?.PreChatSurvey.email : 'test@dfbt.com' },
        { title: 'phoneNumber', value: '' },
        { title: 'product', value: product },
        { title: 'inquiry', value: "" },
        { title: 'subinquiry', value: "" },
        { title: 'deposit', value: "" },
      ];

      let engagementParamters = { Brand: brand };
      customValues.forEach((item) => {
        engagementParamters = { ...engagementParamters, [item.title]: item.value };
      });

      const userData = {
        customerIdentifier: mEmail || config?.PreChatSurvey.email || 'test@dafabet.com',
        customerIdentifiers: {
          emailAddresses: [mEmail || config?.PreChatSurvey.email || 'test@dafabet.com'],
          username: [mUsername || config?.PreChatSurvey.username || 'dafabet'],
        },
        displayName: mUsername || config?.PreChatSurvey.username || 'dafabet',
        firstName: mUsername || config?.PreChatSurvey.username || 'dafabet',
        emailAddress: mEmail || config?.PreChatSurvey.email || 'test@dafabet.com',
        engagementParamters: engagementParamters,
      };

      // Uncomment these lines if using engagement-related actions
      // dispatch(resetEngagement());
      // dispatch(setEngagementParameters(engagementParamters));

      dispatch(signIn(userData, engagementParamters));
      dispatch(setPage('chat')); // Change the page to 'chat' after signing in
    }
  };

  useEffect(() => {
    if (config) {
      AutoSubmit();
    }
  }, [config]); // Dependencies on `config`

  return (
    <div id="live-chat-app">
      {/* Your live chat UI */}
    </div>
  );
};

export default AutoSignIn;
